// extracted by mini-css-extract-plugin
export default {"jumbo":"jumbo_jumbo__4CsSo"};